import { combineReducers } from 'redux'
import companyUser from './reducers/companyUser'
import company from './reducers/company'
import companyCategory from './reducers/companyCategory'
import category from './reducers/category'
import auth from './reducers/auth'
import acl from './reducers/acl'
import activityLog from './reducers/activityLog'


export default combineReducers({
  companyUser,
  company,
  companyCategory,
  category,
  auth,
  acl,
  activityLog,
})
